var DateRangePickerModule = (function () {
    function DateRangePickerModule() {
    }
    return DateRangePickerModule;
}());
export { DateRangePickerModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.module.ts.pre-build-optimizer.js